import { render, staticRenderFns } from "./ItemListView.vue?vue&type=template&id=bb058b1c"
import script from "./ItemListView.vue?vue&type=script&lang=js"
export * from "./ItemListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports